import { Box, Button, Checkbox } from '@mui/material';
import styles from './settings.module.css';
import React, { useMemo, useState } from 'react';
import { useEffect } from 'react';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { toggleLoader } from '../../store/loader/loaderReducer';
import { toast } from 'react-toastify';
import "cropperjs/dist/cropper.css";
import { signatureId_action } from '../../store/signatureId/signatureIdAction';
import SignatureField from '../../component/SignatureField';
import CheckedIcon from '../../component/checkedIcon';
import Skeleton from '@mui/material/Skeleton';
import OverlayBoxes from './OverlayBoxes';
import WebhooksPage from './WebhooksPage';
import EmailTemplates from './EmailTemplates';
import OrganizationDetails from './OrganiZation';
import SMTPSettings from './SMTPSetttings';
import AppHeader from '../../component/appHeader/AppHeader';

const initialState = { type: 1, draw: 1, upload: 1 };
const colors = ['#000', '#1e87ca', '#ac3235', '#108473'];
const textColor = ['black', 'dodgerblue', 'brown', 'seagreen'];

const Settings = () => {
  const document = useSelector((state) => state?.document?.value);
  const dispatch = useDispatch();

  const [toggleNewContact, setToggleNewContact] = useState(false);
  const [type, setType] = useState('draw');
  const [color, setColor] = useState('#000');
  const [font, setFont] = useState('Square Peg');
  const [getImage, setGetImage] = useState({});
  const [getText, setGetText] = useState(null);
  const [imgType, setImgType] = useState('');
  const [getRes, setGetRes] = useState(false);
  const [signType, setSignType] = useState(initialState);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState(() => {
    return sessionStorage.getItem("activeTab") || "Signature";
  });

  const user_detail = useSelector((state) => state.welcomeImgDetail.value);

  useEffect(() => {
    fetchSign();
  }, []);

  const planDetails = useMemo(() => {
    try {
      return user_detail?.plan_details ? JSON.parse(user_detail.plan_details) : {};
    } catch {
      return {};
    }
  }, [user_detail?.plan_details]);

  const isAdmin = useMemo(() => {
    const userRole = user_detail?.user_information?.userRole;

    const roles = Array.isArray(userRole) ? userRole : [userRole].filter(Boolean);

    return roles.some(role => ["Super Admin", "Admin"].includes(role));
  }, [user_detail?.user_information?.userRole]);

  const tabs = useMemo(() => {
  const BASE_TABS = ["Signature", "Oauth"];
  const EXTRA_TABS = {
    WEBHOOKS: "Webhooks",
    EMAIL_TEMPLATES: "Email templates",
    ORGANIZATION: "Organization", 
    SMTP_SETTINGS: "SMTP Settings"
  };

  const extraTabs = [EXTRA_TABS.WEBHOOKS];

  const showFeatures = user_detail?.show_features;
  const parsedFeatures = showFeatures ? JSON.parse(showFeatures) : [];
  const features = parsedFeatures[0]?.features || {};

  const hasPremiumAccess = ["tier2", "enterprise"].includes(planDetails?.plan_name) || isAdmin;

  if (hasPremiumAccess) {
    Object.entries({
      EMAIL_TEMPLATES: EXTRA_TABS.EMAIL_TEMPLATES,
      ORGANIZATION: EXTRA_TABS.ORGANIZATION,
      SMTP_SETTINGS: EXTRA_TABS.SMTP_SETTINGS
    }).forEach(([featureKey, tabName]) => {
      if (features[featureKey]) {
        extraTabs.push(tabName);
      }
    });
  }

  return [...BASE_TABS, ...extraTabs];
}, [planDetails?.plan_name, isAdmin, user_detail?.show_features]);

  const dataURLtoBlob = (dataURL) => {
    let arr = dataURL.split(',');
    let mime = arr[0].match(/:(.*?);/)[1];
    let b64 = atob(arr[1]);
    let n = b64.length;
    let u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = b64.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  };

  const handleSubmit = async (value) => {
    let img = type === 'upload' ? imgType : 'sign.jpeg';
    let blob = dataURLtoBlob(value);
    let file = new File([blob], img);

    if (type === 'type') {
      const paddedText = ' ' + getText?.trim();
      let textDetails = {
        text: paddedText,
        font_size: 60,
        font_color: textColor[colors.indexOf(color)],
        font_family: font === 'Square Peg' ? 'square_peg' : font === 'Caveat' ? 'caveat' : 'bad_script'
      };

      dispatch(toggleLoader(true));
      axios.post(process.env.REACT_APP_TEXT_SIGNATURE, textDetails, { withCredentials: process.env.REACT_APP_CREDENTIALS, responseType: 'blob' })
        .then((res) => {
          let file_ = new File([res.data], img);
          let imgUrl = URL.createObjectURL(res.data);
          setGetImage(imgUrl);
          handleSignSubmit({ file: file_, org_id: document?.OrgId });
        })
        .catch((err) => {
          dispatch(toggleLoader(false));
          toast.error(err.message);
        });
    } else {
      handleSignSubmit({ file: file, org_id: document?.OrgId });
    }
  };

  const handleSignSubmit = (form) => {
    const formData = new FormData();

    Object.keys(form).forEach((key) => {
      formData.append(key, form[key]);
    });

    dispatch(toggleLoader(true));
    axios.post(process.env.REACT_APP_SIGNSETTING_DRIVE, formData, { withCredentials: process.env.REACT_APP_CREDENTIALS })
      .then((res) => {
        if (res.status === 200) {
          setToggleNewContact(false);
          dispatch(toggleLoader(false));
          dispatch(signatureId_action(res?.data?.response?.Sign_Image));
        }
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(toggleLoader(false));
      });
    setToggleNewContact(false);
  };

  const fetchSign = () => {
    dispatch(toggleLoader(true));
    axios.get(process.env.REACT_APP_SIGNSETTING, {
      withCredentials: process.env.REACT_APP_CREDENTIALS,
      params: { org_id: document?.OrgId },
    })
      .then((res) => {
        if (!res.data) {
          setGetImage(null);
          setGetRes(true);
          dispatch(toggleLoader(false));
        } else {
          let data = res?.data?.settings?.sign_image;
          if (data) {
            dispatch(signatureId_action(res?.data?.settings?.sign_image));
            getSignatureImg(res?.data);
          } else {
            setGetRes(true);
            dispatch(toggleLoader(false));
          }
          let type = JSON?.parse(res?.data?.settings?.signature_options);
          setSignType(type);
        }
      })
      .catch((err) => {
        toast.error(err.message);
        dispatch(toggleLoader(false));
      })
  };

  const getSignatureImg = (list) => {
    axios.get(process.env.REACT_APP_SIGNSETTING_DRIVE, {
      responseType: 'blob',
      withCredentials: process.env.REACT_APP_CREDENTIALS,
      params: { org_id: document?.OrgId, file_id: list?.settings?.sign_image },
    })
      .then((res) => {
        let imgUrl = URL.createObjectURL(res.data);
        setGetRes(true);
        setGetImage(imgUrl);
        dispatch(toggleLoader(false));
      })
      .catch((err) => {
        toast.error(err.message);
        setGetRes(true);
        dispatch(toggleLoader(false));
      })
      .finally(() => dispatch(toggleLoader(false)));
  };

  const handleSignCheckBox = (e, key) => {
    const val = e.target.checked ? 1 : 0;
    setSignType({ ...signType, [key]: val })
    setLoading(false);
  };

  const handleSignType = () => {
    dispatch(toggleLoader(true));
    let options = { org_id: document?.OrgId, signature_options: signType };
    axios.put(process.env.REACT_APP_SIGNSETTING, options, { withCredentials: process.env.REACT_APP_CREDENTIALS })
      .then((res) => {
        setLoading(true);
        dispatch(toggleLoader(false));
        toast.success('Success');
      })
      .catch((err) => {
        setLoading(true);
        toast.error(err.message);
        dispatch(toggleLoader(false));
      })
  };

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    sessionStorage.setItem("activeTab", tab);
  };

  return (
    <div className={styles.inn_sec}>
      <div className={styles.tabs}>
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`${styles.tab} ${activeTab === tab ? styles.active : ""}`}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </div>
        ))}
      </div>
      <Box className={styles.tab_content}>
        {(() => {
          switch (activeTab) {
            case "Webhooks":
              return <WebhooksPage />;
            case "Oauth":
              return <OverlayBoxes />;
            case "Email templates":
              return <EmailTemplates />;
            case "Organization":
              return <OrganizationDetails />;
            case "SMTP Settings":
              return <SMTPSettings />;
            case "Signature":
              return <>{getRes ?
                <div className={styles.wrapper}>
                  <AppHeader
                    moduleText='Sign Settings'
                    rolePermissions={true}
                    checkAdmin={true}
                  />
                  <span
                    id='sign'
                    style={{
                      position: 'absolute',
                      fontSize: '50px',
                      top: '-1000%',
                      fontFamily: font,
                      color: color,
                    }}
                  >
                    {getText}
                  </span>

                  <div className={styles.scroll_y}>
                    <div className={styles.default_sign} id={styles.default_sign}>
                      <h3>Sign</h3>
                      <div className={styles.b_cont}>
                        <div className={styles.wrapper}>
                          <div className={styles.row}>
                            <div className={styles.sign_frame} style={{ position: 'relative' }}>
                              <div className={styles.signature_img}>
                                {getImage && Object.keys(getImage).length ? (
                                  <img
                                    width='100%'
                                    height='100%'
                                    style={{ position: 'absolute', objectFit: 'scale-down' }}
                                    src={getImage}
                                    alt='signature'
                                  />
                                ) : null}
                              </div>
                            </div>
                            <Button onClick={() => setToggleNewContact(true)} className={styles.btn + ' ' + styles.sign_btn} id={styles.change_sign} variant="contained">
                              {getImage && Object.keys(getImage).length ? 'Change Signature' : 'Add Signature'}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <Box className={styles.scroll_y}>
                    <Box className={styles.default_sign} id={styles.default_sign}>
                      <h3>Sign Setting Type</h3>
                      <Box className={styles.b_cont} style={{ display: 'flex' }}>
                        <Box className={styles.signTypeSection}>
                          {[
                            {
                              key: 'draw',
                              label: 'Draw',
                              color: 'blue'
                            },
                            {
                              key: 'type',
                              label: 'Type',
                              color: 'purple'
                            },
                            {
                              key: 'upload',
                              label: 'Upload',
                              color: 'emerald'
                            }
                          ].map(({ key, label, Icon, color }) => (
                            <Box
                              key={key}
                              className={styles.signTypeOption}
                              onClick={(e) => {
                                // Only trigger if clicking outside the checkbox itself
                                const isCheckbox = e.target.type === 'checkbox' ||
                                                  e.target.closest('[type="checkbox"]') ||
                                                  e.target.closest('.MuiCheckbox-root');
                                if (!isCheckbox) {
                                  const checkbox = e.currentTarget.querySelector('input[type="checkbox"]');
                                  if (checkbox) {
                                    checkbox.click();
                                  }
                                }
                              }}
                            >
                              
                              <Checkbox
                                className={styles.signTypeCheckbox}
                                sx={{
                                  color: 'var(--border-color)'
                                }}
                                checkedIcon={<CheckedIcon style={{ margin: 2 }} />}
                                checked={!!signType?.[key]}
                                onClick={(e) => handleSignCheckBox(e, key)}
                              />
                              <Box className={styles.signTypeLeft}>
                                <Box className={styles.signTypeLabel}>{label}</Box>
                              </Box>
                            </Box>
                          ))}
                        </Box>
                        <Box className={styles.button_container}>
                          <Button onClick={() => { !loading && handleSignType() }} sx={{ cursor: loading && 'not-allowed' }} className={styles.sign_save_button} variant="contained">
                            Save
                          </Button>
                        </Box>
                      </Box>
                    </Box>
                  </Box>
                </div> : <Skeleton sx={{ bgcolor: 'rgba(189,197,209,.2)', margin: '10px' }} animation="wave" variant="rounded" width={'calc(100% - 20px)'} height={'calc(100vh - 80px)'} />
              }</>

            default:
              return null;
          }
        })()}
      </Box>
      <SignatureField
        toggleNewContact={toggleNewContact}
        getText={(e) => setGetText(e)}
        getGetImage={(e) => setGetImage(e)}
        getToggleNewContact={(value) => setToggleNewContact(value)}
        handleSubmit={handleSubmit}
        getType={(type) => setType(type)}
        getColor={(color) => setColor(color)}
        getFont={(font) => setFont(font)}
        getImageType={(imageType) => setImgType(imageType)}
      />
    </div>
  );
};

export default Settings;